import { create } from "zustand";

type LoadingState = {
  loading: boolean;
  magicLoading: boolean;
  setLoading: (loading: boolean) => void;
  setMagicLoading: (magicLoading: boolean) => void;
};

export const useLoadingStore = create<LoadingState>((set) => ({
  loading: false,
  magicLoading: false,
  setLoading: (loading) => set({ loading }),
  setMagicLoading: (magicLoading) => set({ magicLoading }),
}));
